import React, { useRef, useState, useEffect, useContext } from "react";

import axios from "axios";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import BuyAndSellMarket from "./BuySellMarket";
import BuyAndSellLimit from "./BuySellLimit";
import BuyAndSellStopLimit from "./BuySellStopLimit";
import BuyAndSellIOC from "./BuySellIOC";
import BuyAndSellOCO from "./BuySellOCO";
import { useNavigate } from "react-router-dom";
import { DataContext } from ".";
import { useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const BuyAndSell = () => {
  const {
    isPublicView,
    currencycode,
    basecurrency,
    ltp,
    setRefresh,
    refresh,
    updateBalance,
    setSellData,
    setBuyData,
    sellData,
    buyData,
  } = useContext(DataContext);
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("MARKET");
  const [isOrderTypeDropdownEnabled, setIsOrderTypeDropdownEnabled] =
    useState(false);
  const [selectedOrderType, setSelectedOrderType] = useState("GTC");
  const [activeTabForSpot, setActiveTabForSpot] = useState("orderType");

  const [showOrderTypeDropdown, setShowOrderTypeDropdown] = useState(false);
  const [buySellPillsClassStatus, setBuySellPillsClassStatus] = useState(null);
  const [orderValues, setOrderValues] = useState({
    disclosedQuantity: null,
    limitAmountForOco1: null,
    limitTotalForOco1: null,
    limitPriceForOco1: null,
    limitAmountForOco2: null,
    limitTotalForOco2: null,
    limitPriceForOco2: null,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [balanceList, setBalanceList] = useState([]);
  const [selectedBuyingAssetBalance, setSelectedBuyingAssetBalance] =
    useState(null);
  const [selectedSellingAssetBalance, setSelectedSellingAssetBalance] =
    useState(null);
  const [percentageValue, setPercentageValue] = useState(null);
  const [minBuySellAmount, setMinBuySellAmount] = useState(null);

  const getUserTransaction = async () => {
    setIsLoading(true);
    setRefresh(!refresh);

    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };

    const selectedMarginType = localStorage.getItem("selectedMarginType");
    if (selectedMarginType) {
      userTransObj.marginType = selectedMarginType;
    }

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getUserBalance`,
        JSON.stringify(userTransObj),
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );

      const result = response.data;
      if (result.error.error_data !== 0) {
        alert("Cannot fetch user balance");
      } else {
        setBalanceList(result.userBalanceList);

        // Store USD balance
        const usdBalance = result.userBalanceList.find(
          (item) => item.currencyCode === "USD"
        );
        if (usdBalance) {
          localStorage.setItem("usdbalance", usdBalance.closingBalance);
        }

        // Set selected asset balances
        const pricePrecision = 6;

        result.userBalanceList.forEach((item) => {
          if (item.currencyCode === currencycode) {
            setSelectedBuyingAssetBalance(
              Number(item.closingBalance).toFixed(pricePrecision)
            );
          }
          if (item.currencyCode.toUpperCase() === basecurrency) {
            setSelectedSellingAssetBalance(
              Number(item.closingBalance).toFixed(pricePrecision)
            );
          }
        });

        const currencyDetails = result.userBalanceList.find(
          (item) => item.currencyCode === currencycode.toUpperCase()
        );
        console.log(
          "User balance list:",
          currencyDetails,
          result.userBalanceList
        );
        const response = await getTokenType(currencyDetails?.currencyId);
        console.log("Token type response:", response?.response[0]);
        const tokenType = response?.response[0]?.tokenType;
        getCurrencyMinimumAmount(currencyDetails?.currencyId, tokenType);
      }
    } catch (error) {
      console.error(error);
      if (error.response?.status === 401) {
        showToast("error", "Session Timeout. Login Again");
        // Perform logout logic
        //logout
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getTokenType = async (currencyId) => {
    const payload = { currencyId };

    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/currencyTokenTypeById`,
        JSON.stringify(payload),
        {
          headers: {
            "Content-Type": "application/json",
            authorization: "BEARER " + localStorage.getItem("access_token"),
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching token type:", error);
    }
  };

  const getCurrencyMinimumAmount = async (currencyId, tokenType) => {
    const payload = {
      currencyId: currencyId,
      userCountry: localStorage.getItem("userCountry"),
      tokenType: tokenType,
    };
    try {
      const response = await axios.post(
        `${WEBSERVICE}transaction/getFeesByCurrencyId`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${localStorage.getItem("access_token")}`,
          },
        }
      );
      console.log("Minimum amount response:", response.data);
      const fees = response.data?.fees;
      setMinBuySellAmount(fees);
    } catch (error) {
      console.error("Error fetching currency minimum amount:", error);
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  useEffect(() => {
    if (isPublicView) return;
    getUserTransaction();
  }, [currencycode, basecurrency, updateBalance]);
  useEffect(() => {
    if (isPublicView) return;
    getFeesOfUser();
  }, []);

  const getFeesOfUser = async () => {
    try {
      const uuid = localStorage.getItem("uuid");
      const token = localStorage.getItem("access_token");

      if (!uuid || !token) {
        console.error("UUID or access token missing");
        return;
      }

      const response = await axios.get(
        `${WEBSERVICE}userTrade/userTradingFeeByVolume`,
        {
          params: { uuid, offerType: "M" },
          headers: {
            "Content-Type": "application/json",
            Authorization: `BEARER ${token}`,
          },
        }
      );

      const fee = response.data.tradingFee;
      const calculatedFee = (fee + 0.01) / 100;
      setPercentageValue(calculatedFee);
    } catch (error) {
      console.error("Error fetching user trading fee:", error);
    }
  };

  const handleOrderTypeOption = () => {
    setIsOrderTypeDropdownEnabled(!isOrderTypeDropdownEnabled);
  };

  const handleSelectOrderType = (param) => {
    setSelectedOrderType(param);
    setIsOrderTypeDropdownEnabled(false);

    if (param === "GTC") {
      setActiveTabForSpot("stop-limit");
    } else {
      setActiveTabForSpot("orderType");
    }
  };

  const handleShowOrderTypeDropdown = (param) => {
    setOrderValues({
      disclosedQuantity: null,
      limitAmountForOco1: null,
      limitTotalForOco1: null,
      limitPriceForOco1: null,
      limitAmountForOco2: null,
      limitTotalForOco2: null,
      limitPriceForOco2: null,
    });

    if (param.toLowerCase() === "limit") {
      setShowOrderTypeDropdown(true);
    } else {
      setShowOrderTypeDropdown(false);
    }
  };

  const makeClassToggle = (status) => {
    setBuySellPillsClassStatus(status);
  };

  return (
    <div>
      {/* Tab bar */}
      <div className="bs-tabbar">
        {["MARKET", "LIMIT"].map((tab) => (
          <button
            key={tab}
            className={`bs-tab ${activeTab === tab ? "active-bs-tab" : ""}`}
            style={activeTab === tab ? { "--btn-color": btncolor } : {}}
            onClick={() => {
              setActiveTab(tab);
              handleShowOrderTypeDropdown(tab);
              makeClassToggle(true);
              setSellData("");
              setBuyData("");
            }}
          >
            {tab}
          </button>
        ))}

        <button
          className={`bs-tab ${
            activeTab === "STOP-LIMIT" ||
            activeTab === "IOC" ||
            activeTab === "FOK" ||
            activeTab === "OCO"
              ? "active-bs-tab"
              : ""
          }`}
          style={
            activeTab === "STOP-LIMIT" ||
            activeTab === "IOC" ||
            activeTab === "FOK" ||
            activeTab === "OCO"
              ? { "--btn-color": btncolor }
              : {}
          }
          onClick={() => {
            setActiveTab(
              selectedOrderType === "GTC" ? "STOP-LIMIT" : selectedOrderType
            );
            setSellData("");
            setBuyData("");
          }}
        >
          {selectedOrderType === "GTC" ? "STOP-LIMIT" : selectedOrderType}
        </button>

        <span className="bs-tab-caret-wrapper">
          <span className="bs-tab-caret" onClick={handleOrderTypeOption}>
            <KeyboardArrowDownIcon style={{ fontSize: 18 }} />
          </span>

          {isOrderTypeDropdownEnabled && (
            <div className="bs-tab-dropdown">
              <ul>
                <li
                  onClick={() => {
                    handleSelectOrderType("IOC");
                    setActiveTab("IOC");
                  }}
                >
                  IOC
                </li>
                <li
                  onClick={() => {
                    handleSelectOrderType("FOK");
                    setActiveTab("FOK");
                  }}
                >
                  FOK
                </li>
                <li
                  onClick={() => {
                    handleSelectOrderType("OCO");
                    setActiveTab("OCO");
                  }}
                >
                  OCO
                </li>
                {selectedOrderType !== "GTC" && (
                  <li
                    onClick={() => {
                      handleSelectOrderType("GTC");
                      setActiveTab("STOP-LIMIT");
                    }}
                  >
                    STOP-LIMIT
                  </li>
                )}
              </ul>
            </div>
          )}
        </span>
      </div>

      {activeTab === "MARKET" && (
        <BuyAndSellMarket
          selectedBuyingAssetBalance={selectedBuyingAssetBalance}
          selectedSellingAssetBalance={selectedSellingAssetBalance}
          percentageValue={percentageValue}
          getUserTransaction={getUserTransaction}
          minBuySellAmount={minBuySellAmount}
        />
      )}
      {activeTab === "LIMIT" && (
        <BuyAndSellLimit
          selectedBuyingAssetBalance={selectedBuyingAssetBalance}
          selectedSellingAssetBalance={selectedSellingAssetBalance}
          percentageValue={percentageValue}
          getUserTransaction={getUserTransaction}
          selectedOrderType={selectedOrderType}
          minBuySellAmount={minBuySellAmount}
        />
      )}
      {activeTab === "STOP-LIMIT" && (
        <BuyAndSellStopLimit
          selectedBuyingAssetBalance={selectedBuyingAssetBalance}
          selectedSellingAssetBalance={selectedSellingAssetBalance}
          percentageValue={percentageValue}
          getUserTransaction={getUserTransaction}
          minBuySellAmount={minBuySellAmount}
        />
      )}
      {(activeTab === "IOC" || activeTab === "FOK") && (
        <BuyAndSellIOC
          selectedBuyingAssetBalance={selectedBuyingAssetBalance}
          selectedSellingAssetBalance={selectedSellingAssetBalance}
          percentageValue={percentageValue}
          selectedOrderType={selectedOrderType}
          getUserTransaction={getUserTransaction}
          minBuySellAmount={minBuySellAmount}
        />
      )}
      {activeTab === "OCO" && (
        <BuyAndSellOCO
          selectedBuyingAssetBalance={selectedBuyingAssetBalance}
          selectedSellingAssetBalance={selectedSellingAssetBalance}
          percentageValue={percentageValue}
          selectedOrderType={selectedOrderType}
          getUserTransaction={getUserTransaction}
          minBuySellAmount={minBuySellAmount}
        />
      )}
    </div>
  );
};

export default BuyAndSell;
